// 原 APP GameOpenScene 的純時序規則；CDiceScene 依此排程，測試可直接驗證。

const DICE_FLY_MS = 2000; // DiceEntity：MoveToX／MoveToY 固定 2 秒
const OPEN_WIND_SOUND_RATIO = 0.9; // WindRoundAnim：骰子動畫進度 90% 時報風局
const WORD_REVEAL_GAP_MS = 400; // WindRoundAnim.WORD_DELAY_TIME
const FINAL_WORD_HOLD_MS = 900; // 第四字「局」出現後的停留
const WORD_COUNT = 4;

export interface IGameOpenTimeline {
  readonly diceFlyMs: number;
  readonly openWindSoundAtMs: number;
  readonly wordRevealAtMs: number[];
  readonly finishAtMs: number;
}

export function buildGameOpenTimeline(): IGameOpenTimeline {
  const wordRevealAtMs = Array.from(
    { length: WORD_COUNT },
    (_, index) => DICE_FLY_MS + index * WORD_REVEAL_GAP_MS
  );
  return {
    diceFlyMs: DICE_FLY_MS,
    openWindSoundAtMs: DICE_FLY_MS * OPEN_WIND_SOUND_RATIO,
    wordRevealAtMs,
    finishAtMs: DICE_FLY_MS + (WORD_COUNT - 1) * WORD_REVEAL_GAP_MS + FINAL_WORD_HOLD_MS,
  };
}
